import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    CategoryPageContainer as SourceCategoryPageContainer,
    mapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
} from 'SourceRoute/CategoryPage/CategoryPage.container';
import CategoryReducer from 'Store/Category/Category.reducer';
import { withReducers } from 'Util/DynamicReducer';
import { debounce } from 'Util/Request';

import { LOADING_TIME } from './CategoryPage.config';

export { mapDispatchToProps };

/** @namespace AdvoxBasic/Route/CategoryPage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    isTablet: state.ConfigReducer.device.isTablet,
});

/** @namespace AdvoxBasic/Route/CategoryPage/Container/CategoryPageContainer */
export class CategoryPageContainer extends SourceCategoryPageContainer {
    static propTypes = {
        ...SourceCategoryPageContainer.propTypes,
        isTablet: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        ...SourceCategoryPageContainer.defaultProps,
    };

    componentDidUpdate(prevProps) {
        const {
            isOffline,
            categoryIds,
            category: { id },
            currentArgs: { filter } = {},
            sortFields,
        } = this.props;

        const { breadcrumbsWereUpdated } = this.state;

        const {
            categoryIds: prevCategoryIds,
            category: { id: prevId },
            currentArgs: { filter: prevFilter } = {},
            sortFields: prevSortFields,
        } = prevProps;

        if (isOffline) {
            debounce(this.setOfflineNoticeSize, LOADING_TIME)();
        }

        if (categoryIds !== prevCategoryIds) {
            this.updateHistory();
        }

        if (categoryIds !== id) {
            this.requestCategory();
        }

        const categoryChange = id !== prevId || (!breadcrumbsWereUpdated && id === categoryIds);

        if (categoryChange) {
            this.checkIsActive();
            this.updateMeta();
            this.updateBreadcrumbs();
            this.updateHeaderState();
        }

        if (
            !categoryChange &&
            filter &&
            prevFilter &&
            Object.keys(filter.customFilters).length !== Object.keys(prevFilter.customFilters).length
        ) {
            this.updateMeta();
        }

        if (sortFields !== prevSortFields && sortFields) {
            const { options } = sortFields;

            if (options) {
                const { value } = options[0];

                this.config = {
                    sortKey: value,
                    sortDirection: 'ASC',
                };
            }
        }
    }

    containerProps() {
        const {
            category,
            filters,
            isMobile,
            sortFields,
            toggleOverlayByKey,
            totalPages,
            totalItems,
            isTablet,
            isBrandPage,
            isSearchPage,
        } = this.props;

        const { brandData } = this.state;

        return {
            appliedFiltersCount: this.getAppliedFiltersCount(),
            category,
            defaultPlpType: this.getDefaultPlpType(),
            filter: this.getFilter(),
            filters,
            isContentFiltered: this.isContentFiltered(),
            isCurrentCategoryLoaded: this.isCurrentCategoryLoaded(),
            isMatchingInfoFilter: this.getIsMatchingInfoFilter(),
            isMatchingListFilter: this.getIsMatchingListFilter(),
            isMobile,
            plpTypes: this.getPlpTypes(),
            selectedFilters: this.getSelectedFiltersFromUrl(),
            selectedSort: this.getSelectedSortFromUrl(),
            sortFields,
            toggleOverlayByKey,
            totalPages,
            totalItems,
            isTablet,
            isBrandPage,
            brandFilterId: (brandData && brandData.option_id) || '',
            isSearchPage,
        };
    }

    isCurrentCategoryLoaded() {
        const {
            categoryIds,
            category: { id },
            isSearchPage,
            isBrandPage,
        } = this.props;

        return isSearchPage || isBrandPage || categoryIds === id;
    }

    requestCategory() {
        const { categoryIds, isSearchPage, isBrandPage, requestCategory } = this.props;

        const { currentCategoryIds } = this.state;

        /**
         * Prevent non-existent category from being requested
         */
        if (categoryIds === -1) {
            return;
        }

        /**
         * Do not request a category again! We are still waiting for
         * a requested category to load!
         */
        if (categoryIds === currentCategoryIds) {
            return;
        }

        /**
         * Update current category to track if it is loaded or not - useful,
         * to prevent category from requesting itself multiple times.
         */
        this.setState({
            currentCategoryIds: categoryIds,
            breadcrumbsWereUpdated: false,
        });

        requestCategory({
            isSearchPage,
            isBrandPage,
            categoryIds,
            requireInfo: isBrandPage && true,
        });
    }

    getFilter() {
        const { categoryIds, isBrandPage } = this.props;
        const customFilters = this.getSelectedFiltersFromUrl();
        const priceRange = this.getSelectedPriceRangeFromUrl();
        const { brandData } = this.state;

        if (isBrandPage) {
            customFilters.manufacturer = { eq: brandData?.option_id };
        }

        if (categoryIds === -1) {
            return {
                priceRange,
                customFilters,
            };
        }

        return {
            priceRange,
            customFilters,
            categoryIds,
        };
    }
}

export default withReducers({
    CategoryReducer,
})(connect(mapStateToProps, mapDispatchToProps)(CategoryPageContainer));
